import { render, staticRenderFns } from "./PageDataTableRow.vue?vue&type=template&id=777cbbb0&"
import script from "./PageDataTableRow.vue?vue&type=script&lang=js&"
export * from "./PageDataTableRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports